import { FileDoneOutlined, FileSyncOutlined } from "@ant-design/icons";
import { toPairs } from "lodash";

export const ML_SOFTWARE_QC_FLAGS = {
  "-": {
    value: "-",
    label: "-",
    status: "-",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
    className: "ReportStatusFlag__0",
  },
  "-1": {
    value: -1,
    label: "Unable to QC",
    status: "Unable to QC",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
    className: "ReportStatusFlag__-1",
  },
  0: {
    value: 0,
    label: "Not QCed",
    status: "Pending",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
    className: "ReportStatusFlag__0",
  },
  1: {
    value: 1,
    label: "QC Passed",
    status: "Passed",
    style: {
      color: "#1EC04A",
      backgroundColor: "#E9FFEF",
      borderColor: "#1EC04A",
    },
    className: "ReportStatusFlag__1",
  },
  2: {
    value: 2,
    label: "QC Failed",
    status: "Failed",
    style: {
      color: "#E11903",
      backgroundColor: "#FFE1E1",
      borderColor: "#E11903",
    },
    className: "ReportStatusFlag__2",
  },
  3: {
    value: 3,
    label: "No History",
    status: "No History",
    style: {
      color: "#FF9F3F",
      backgroundColor: "#FFF7EF",
      borderColor: "#FF9F3F",
    },
    className: "ReportStatusFlag__3",
  },
};

export const MANUAL_QC_FLAGS = {
  "-": {
    value: "-",
    label: "-",
    status: "-",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
    className: "ReportStatusFlag__0",
  },
  0: {
    value: 0,
    label: "Pending",
    status: "Pending",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
    className: "ReportStatusFlag__0",
  },
  1: {
    value: 1,
    label: "Pass",
    status: "Passed",
    style: {
      color: "#1EC04A",
      backgroundColor: "#E9FFEF",
      borderColor: "#1EC04A",
    },
    className: "ReportStatusFlag__1",
  },
  2: {
    value: 2,
    label: "Hold",
    status: "Failed",
    style: {
      color: "#E11903",
      backgroundColor: "#FFE1E1",
      borderColor: "#E11903",
    },
    className: "ReportStatusFlag__2",
  },
  3: {
    value: 3,
    label: "Retest",
    status: "Retest",
    style: {
      color: "#FF9F3F",
      backgroundColor: "#FFF7EF",
      borderColor: "#FF9F3F",
    },
    className: "ReportStatusFlag__3",
  },
  4: {
    value: 4,
    label: "RCA",
    status: "RCA",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
    className: "ReportStatusFlag__4",
  },
};

export const REPORT_STATUS_FLAGS = {
  "-": {
    value: 0,
    label: "Pending",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
    className: "ReportStatusFlag__0",
  },
  0: {
    value: 0,
    label: "Pending",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
    className: "ReportStatusFlag__0",
  },
  1: {
    value: 1,
    label: "Approved",
    style: {
      color: "#1EC04A",
      backgroundColor: "#E9FFEF",
      borderColor: "#1EC04A",
    },
    className: "ReportStatusFlag__1",
  },
  2: {
    value: 2,
    label: "Hold",
    style: {
      color: "#E11903",
      backgroundColor: "#FFE1E1",
      borderColor: "#E11903",
    },
    className: "ReportStatusFlag__2",
  },
  3: {
    value: 3,
    label: "Retesting",
    style: {
      color: "#FF9F3F",
      backgroundColor: "#FFF7EF",
      borderColor: "#FF9F3F",
    },
    className: "ReportStatusFlag__3",
  },
};

export const BATCH_REPORT_TEST_STATUS = {
  "-": {
    value: "-",
    label: "-",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
  },
  Pending: {
    value: "Pending",
    label: "Pending",
    style: {
      color: "#ff0000",
    },
  },
  Ready: {
    value: "Ready",
    label: "Ready",
    style: {
      color: "#008000",
    },
  },
  "Ready-P": {
    value: "Ready-P",
    label: "Ready-P",
    style: {
      color: "#008000",
    },
  },
  Complete: {
    value: "Complete",
    label: "Complete",
    style: {
      color: "#ea33f7",
    },
  },
  Retest: {
    value: "Retest",
    label: "Retest",
    style: {
      color: "#ff0000",
    },
  },
};

export const REPORT_STATUS_CONFIG = {
  "-": {
    value: "-",
    label: "-",
    style: {
      color: "#000000",
    },
  },
  null: {
    value: null,
    label: "Not Generated",
    style: {
      color: "#000000",
    },
  },
  available: {
    value: "available",
    label: "Available",
    style: {
      color: "#000000",
    },
  },
  history: {
    value: "history",
    label: "History",
    style: {
      color: "#000000",
    },
  },
  pending: {
    value: "pending",
    label: "Pending",
    style: {
      color: "#000000",
    },
  },
  hold: {
    value: "hold",
    label: "Hold",
    style: {
      color: "#000000",
    },
  },
};

export const BATCH_REPORT_WO_STATUS = {
  0: {
    value: "Complete",
    label: "Complete",
    style: {
      color: "#ea33f7",
    },
  },
  1: {
    value: "Pending",
    label: "Pending",
    style: {
      color: "#19305a",
    },
  },
  2: {
    value: "Pending - Special",
    label: "Pending - Special",
    style: {
      color: "#0ac192",
    },
  },
};

export const BATCH_REPORT_GENERATE_STATUS = {
  "-": {
    label: "-",
    style: {
      color: "#000000E0",
      backgroundColor: "#F4F4F4",
      borderColor: "#d9d9d9",
    },
  },
  0: {
    label: "Pending",
    style: { color: "#ff0000" },
  },
  1: {
    label: "Ready",
    style: { color: "#008000" },
  },
  2: {
    label: "Pending - AI QC",
    style: { color: "#ff0000" },
  },
  3: {
    label: "Ready - Awaiting QC Approval",
    style: { color: "#008000" },
  },
  4: {
    label: "Complete",
    style: { color: "#ea33f7" },
  },
};

const TEXT_OVERDUE_FLAG_COMMON_STYLE = {
  width: "18px",
  height: "18px",
  display: "inline-block",
  borderRadius: "50%",
};

export const TEST_OVERDUE_FLAGS = {
  Queue: {
    value: "Queue",
    label: "Queue",
    type: "circle",
    circleStyle: {
      backgroundColor: "black",
      ...TEXT_OVERDUE_FLAG_COMMON_STYLE,
    },
    textStyle: {
      color: "black",
    },
  },
  "Due soon": {
    value: "Due soon",
    label: "Due soon",
    type: "circle",
    circleStyle: {
      backgroundColor: "purple",
      ...TEXT_OVERDUE_FLAG_COMMON_STYLE,
    },
    textStyle: {
      color: "purple",
    },
  },
  "Due today": {
    value: "Due today",
    label: "Due today",
    type: "circle",
    circleStyle: {
      backgroundColor: "green",
      ...TEXT_OVERDUE_FLAG_COMMON_STYLE,
    },
    textStyle: {
      color: "green",
    },
  },
  "Due yesterday": {
    value: "Due yesterday",
    label: "Due yesterday",
    type: "circle",
    circleStyle: {
      backgroundColor: "orange",
      ...TEXT_OVERDUE_FLAG_COMMON_STYLE,
    },
    textStyle: {
      color: "orange",
    },
  },
  Overdue: {
    value: "Overdue",
    label: "Overdue",
    type: "circle",
    circleStyle: {
      backgroundColor: "red",
      ...TEXT_OVERDUE_FLAG_COMMON_STYLE,
    },
    textStyle: {
      color: "red",
    },
  },
  Retest: {
    value: "Retest",
    label: "Retest",
    textName: "Bold",
    type: "text",
    circleStyle: {
      fontWeight: "bold",
    },
    textStyle: {
      fontWeight: "bold",
    },
  },
};

export const REPORT_GENERATION_STATUS = {
  complete: {
    value: 1,
    label: "Complete Report",
    icon: FileDoneOutlined,
    styles: {
      color: "#1EC04A",
    },
  },
  partial: {
    value: 2,
    label: "Partial Report",
    icon: FileSyncOutlined,
    styles: {
      color: "#000000E0",
    },
  },
};

export const CSM_RESULT_STATUS = {
  pending: {
    value: "Pending",
    label: "Pending",
    style: {
      color: "#ff0000",
    },
  },
  on_time: {
    value: "On Time",
    label: "On Time",
    style: {
      color: "#008000",
    },
  },
  delayed: {
    value: "Delayed",
    label: "Delayed",
    style: {
      color: "#ff0000",
    },
  },
};

export const getTestOverdueFlag = (overdueBy) => {
  let flag = "Queue";
  if (overdueBy < 0) {
    flag = "Due soon";
  } else if (overdueBy === 0) {
    flag = "Due today";
  } else if (overdueBy === 1) {
    flag = "Due yesterday";
  } else if (overdueBy >= 2) {
    flag = "Overdue";
  }
  return flag;
};

export const convertStatusMapToArrayOptions = (statusMap, excludeStatus = [], skipDefault = false, labelValueOnly = true) => toPairs(statusMap).reduce((acc, keyValuePair) => {
  const [key, status] = keyValuePair;
  // For dropdown options, we need to add the "All" option.
  if (acc.length === 0 && !skipDefault) {
    acc.push({
      value: "",
      label: "All",
    });
  }
  if (key !== "-" && !excludeStatus.includes(status.value)) {
    // For dropdown options, we only need the label and value. For other cases, we need the entire status object.
    acc.push(labelValueOnly ? { value: status.value, label: status.label } : status);
  }
  return acc;
}, []);
